import { LiveOpsApi, LiveOpsConfigResult, LiveOpsRawConfig } from './LiveOpsApi'
import { LiveOpsCache, LiveOpsHooks, RawLiveOpsResponse } from './LiveOpsCache'
import type { RemoteFunctionInvoker } from '../http/callRemoteFunction'

interface HttpLiveOpsDeps {
  callRemote: RemoteFunctionInvoker
  versionTag?: string
  hooks?: LiveOpsHooks
}

export class HttpLiveOpsApi implements LiveOpsApi {
  private cache: LiveOpsCache

  constructor(
    private gameId: string,
    private deps: HttpLiveOpsDeps,
  ) {
    this.cache = new LiveOpsCache(() => {
      const payload: Record<string, unknown> = { appId: this.gameId }
      if (this.deps.versionTag) payload.versionTag = this.deps.versionTag
      return this.deps.callRemote<RawLiveOpsResponse>('h5/liveops/config', payload)
    }, this.deps.hooks)
  }

  /** Drop cached rules; PlaygroundHost calls this on HMR config change (mirrors HttpSimulationApi). */
  clearConfigCache(): void {
    this.cache.clear()
  }

  getConfigAsync(options?: { maxAgeMs?: number }): Promise<LiveOpsConfigResult> {
    return this.cache.getConfig(options?.maxAgeMs)
  }

  getRawConfigAsync(options?: { maxAgeMs?: number }): Promise<LiveOpsRawConfig> {
    return this.cache.getRaw(options?.maxAgeMs)
  }
}
